
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { EmailAvailabilityRequest, EmailAvailabilityResponse } from '@/utils/a2a/types/schedulerTypes';
import { toast } from 'sonner';

export const useSchedulerEmails = () => {
  const [emailStatus, setEmailStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const sendAvailabilityEmail = async (request: EmailAvailabilityRequest): Promise<EmailAvailabilityResponse | null> => {
    try {
      setEmailStatus('sending');

      const { data: freeBusyData, error: freeBusyError } = await supabase.functions.invoke('scheduling/free-busy', {
        body: JSON.stringify({
          startDate: request.startDate,
          endDate: request.endDate,
          duration: request.duration,
          interviewerIds: request.interviewerIds
        })
      });

      if (freeBusyError) throw freeBusyError;

      const { data: emailData, error: emailError } = await supabase.functions.invoke('scheduling/email-availability', {
        body: JSON.stringify({
          candidate: {
            id: request.candidateId,
            name: request.candidateName,
            email: request.candidateEmail
          },
          job: {
            id: request.jobId,
            title: request.jobTitle
          },
          availabilitySlots: freeBusyData.availabilitySlots,
          notes: request.notes
        })
      });

      if (emailError) throw emailError;

      setEmailStatus('sent');
      toast.success('Availability email sent successfully');

      return emailData;
    } catch (error) {
      console.error('Error sending availability email:', error);
      setEmailStatus('error');
      toast.error('Failed to send availability email');
      return null;
    }
  };

  return {
    emailStatus,
    sendAvailabilityEmail
  };
};
